export type AuthenticationContext = 'SIGN_UP' | 'SIGN_IN';
